<template>
  <div class="notification-stepper container-fluid w-100">
    <div class="card shadow-sm border-0 ">
    <div class="card-body ">
      <div class="d-flex flex-wrap gap-2 w-100">
    <button
      v-for="step in steps"
      :key="step.id"
      class="btn notification-step-btn"
      :class="{ active: activeStep === step.id }"
      @click="$emit('update-step', step.id)"
    >
      {{ step.label }}
    </button>
  </div>
  </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "NotificationStepper",

  props: {
    activeStep: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      steps: [
        { id: 1, label:"General information"},
        { id: 2, label: "Trigger" },
        { id: 3, label: "Recipient" },
        { id: 4, label: "Channel" },
        { id: 5, label: "Scope & Review" },
      ],
    };
  },
};
</script>
<style scoped>
.notification-step-btn {
  min-width: 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.card{
  background-color: #ffffff;
  border-radius: 10px;
  width: 100%;
}

.notification-step-btn.active {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}
</style>